import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=229602a1&scoped=true&"
import script from "./marketplace.vue?vue&type=script&lang=js&"
export * from "./marketplace.vue?vue&type=script&lang=js&"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=229602a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229602a1",
  null
  
)

export default component.exports